import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { TableRow } from '@mui/material';
import { GridHeaderCell } from './grid-header-cell';
export function GridHeader(props) {
    const { columns, ...rest } = props;
    return (_jsx(TableRow, { ...rest, children: columns
            .filter((col) => col != null)
            .filter((col) => col.visible)
            .map((column) => (_jsx(GridHeaderCell, { column: column }, column.name))) }));
}
